export default function (product_json) {
  let variant_skus = [];

  product_json.variants.forEach((item) => {
    variant_skus.push(item.sku);
  });

  const variant_string = variant_skus.toString();

  const url =
    window.Shopify.shop === 'windsor-dev.myshopify.com'
      ? 'https://inventory-lookup-service.wndsr.dev/international_availability?token=s9bf4mDcowLlyL5PIb7KHVa0'
      : 'https://inventory-lookup-service.wndsr.io/international_availability?token=s9bf4mDcowLlyL5PIb7KHVa0';

  // Create fetch timeout function
  async function fetchWithTimeout(resource, options = {}) {
    const { timeout = 8000 } = options;

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(id);
    return response;
  }

  return new Promise((resolve, reject) => {
    try {
      fetchWithTimeout(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          skus: variant_string,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          let inventory_json = {
            color: {},
            size: {},
          };

          Object.keys(data).forEach((international_sku) => {
            product_json.variants.forEach((variant) => {
              if (variant.sku === international_sku) {
                inventory_json.color[variant.id] = data[international_sku] || 0;
              }
              if (variant.sku === international_sku) {
                inventory_json.size[variant.title] = data[international_sku] || 0;
              }
            });
          });

          window.inventory980 = inventory_json;
          resolve(inventory_json);
        })
        .catch((error) => reject(error));
    } catch (error) {
      console.log(error.name === 'AbortError');
      reject(error);
    }
  });
}
